import { Link } from "react-router-dom";
import { storyList } from "@/utils/catalog";
import StoryCard from "@/components/feature/StoryCard";

export default function LatestStory() {
  const latest = storyList.slice(0, 6);

  return (
    <section className="bg-background-100 py-14">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground-900">最新剧情更新</h2>
            <p className="mt-2 text-sm text-foreground-500">跟随更新的脚步，一集一集读懂这个故事。</p>
          </div>
          <Link
            to="/category/story"
            className="inline-flex items-center gap-1 text-sm text-primary-600 transition hover:text-primary-700"
          >
            全部剧情<i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {latest.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}